import React from 'react';

import LastEditorInfo from '../../../app/components/LastEditorInfo';
import { usePokCore } from '../../../common/hooks/usePokCore';

export const BudgetInfo = (props: { id: string }) => {
  const pok = usePokCore();

  return (
    <LastEditorInfo
      id={props.id}
      placement="left"
      method={pok.budgets.getLastEditor}
      className=""
      iconSize={18}
    />
  );
};
